import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";
import { Buffer } from "buffer";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { Divider } from "primereact/divider";
import {
  obtener_concurso,
  obtener_cantidad_concurso,
  obtener_archivos,
  obtener_tipo_contrato,
  obtener_jornada,
  obtener_unidad,
} from "../../Api/api";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeflex/primeflex.css";
import { Column } from "primereact/column";
import { PrimeReactProvider } from "primereact/api";
import "./PlataformaConcursos.css";
import { Concurso, informaciones, jornada, tipo_c, unidad } from "../Concurso";
import IconvLite from "iconv-lite";
import { ProgressSpinner } from "primereact/progressspinner";
import { Slider, SliderChangeEvent } from "primereact/slider";

const concur: Concurso = {
  id: 0,
  titulo: "",
  cargo: "",
  fecha_creacion: new Date(Date.now()),
  fecha_termino: new Date(Date.now()),
  inclusion: false,
  sueldo: 0,
  visible: false,
  tipo_c_id: 0,
  jornada_id: 0,
  unidad_id: 0,
  informaciones: [],
  tipo_c: { id: 0, tipo_c: "" },
  jornada: { id: 0, tipo: "" },
  unidad: { id: 0, unidad: "" },
};
const contrat: tipo_c = { id: NaN, tipo_c: "" };

const uni: unidad = { id: NaN, unidad: "" };

const jor: jornada = { id: NaN, tipo: "" };

const Plataforma_Concursos: React.FC = () => {
  const [informaciones, setInformaciones] = useState<informaciones[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [Titulo, setTitulo] = useState<string>("");
  const [cargando, setCargando] = useState<boolean>(false);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [showInformacion, setShowInformacion] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPage2, setCurrentPage2] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(3);
  const [Totalpaginas, setTotalpaginas] = useState<number>(0);
  const [archiv, setArchiv] = useState<number>(1);
  const [Concursos, setConcursos] = useState<Concurso[]>([]);
  const [unidades, setUnidades] = useState<unidad[]>([]);
  const [contratos, setContratos] = useState<tipo_c[]>([]);
  const [jornadas, setJornadas] = useState<jornada[]>([]);
  const [unidad_seleccionada, setUnidad_seleccionada] = useState<unidad>(uni);
  const [contrato_seleccionado, setContrato_seleccionado] =
    useState<tipo_c>(contrat);
  const [jornada_seleccionada, setJornada_seleccionada] =
    useState<jornada>(jor);
  const [archivoss, setarchivoss] = useState<Concurso[]>([]);
  const [verTodos, setVertodos] = useState<boolean>(false);
  const [inclusion, setInclusion] = useState<boolean>(false);
  const [valMax, setValMax] = useState<number>(15000000);
  const [valMin, setValMin] = useState<number>(0);
  const [cargo, setCargo] = useState<string>("");
  const [precio, setPrecio] = useState<number | [number, number]>([0, 0]);
  const [isPressed, setIsPressed] = useState<boolean>(false);

  useEffect(() => {
    obtenerTiposcontrato();
    obtenerJornadas();
    obtenerUnidades();
  }, []);

  useEffect(() => {
    obtenerConcurso();
    obtenerCantidad();
  }, [currentPage, itemsPerPage, isPressed]);

  const handleSliderChange = (e: SliderChangeEvent) => {
    const [newMin, newMax] = updateSliderValues(
      (e.value as [number, number])[0],
      (e.value as [number, number])[1]
    );
    setValMin(newMin);
    setValMax(newMax);
    setPrecio([newMin, newMax]);
  };

  function updateSliderValues(min: number, max: number): [number, number] {
    if (min > max) {
      return [max, min];
    } else {
      return [min, max];
    }
  }

  function formatNumberWithThousandsSeparator(num: number): string {
    return num.toLocaleString("es-ES", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  const handleClick = () => {
    setIsPressed(!isPressed);
  };

  const obtenerConcurso = async () => {
    await obtener_concurso(
      searchTerm,
      currentPage,
      itemsPerPage,
      verTodos,
      contrato_seleccionado,
      jornada_seleccionada,
      unidad_seleccionada,
      valMax,
      valMin,
      cargo
    )
      .then((data) => {
        console.log(data);
        setConcursos(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerCantidad = async () => {
    await obtener_cantidad_concurso(
      searchTerm,
      verTodos,
      contrato_seleccionado,
      jornada_seleccionada,
      unidad_seleccionada,
      valMax,
      valMin,
      cargo
    )
      .then((data) => {
        setTotalpaginas(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerArchivos_old = async (arch: number) => {
    setCargando(true);
    await obtener_archivos(arch)
      .then((data) => {
        setInformaciones(data[0].informaciones);
        setCargando(false);
      })
      .catch((error) => {
        setCargando(false);
        console.error("Error fetching data:", error);
      });
  };

  const obtenerArchivos = async (arch: number) => {
    setCargando(true);
    await obtener_archivos(arch)
      .then((data) => {
        console.log("Data recibido:", data); // Verifica la estructura completa de los datos
        if (data.length > 0) {
          console.log("Informaciones:", data[0].informaciones); // Intenta acceder a informaciones nuevamente
          setInformaciones(data[0].informaciones || []); // Asegúrate de que sea un array
        } else {
          setInformaciones([]);
        }
        setCargando(false);
      })
      .catch((error) => {
        setCargando(false);
        console.error("Error fetching data:", error);
      });
  };

  const obtenerTiposcontrato = async () => {
    await obtener_tipo_contrato()
      .then((data) => {
        setContratos(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerJornadas = async () => {
    await obtener_jornada()
      .then((data) => {
        setJornadas(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const obtenerUnidades = async () => {
    await obtener_unidad()
      .then((data) => {
        setUnidades(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const OcultarConcursos = () => {
    setShowInformacion(false);
  };

  const MostrarConcursos = (concurso: Concurso) => async () => {
    await SetValores(concurso);
  };

  const SetValores = async (concurso: Concurso) => {
    setArchiv(concurso.id);
    setTitulo(concurso.titulo);
    setShowInformacion(true); // Mostrar la ventana de información de inmediato
    setCargando(true); // Iniciar el spinner de carga
    await obtenerArchivos(concurso.id);
  };

  const hola = (base64: Buffer) => {
    const transforms = IconvLite.decode(base64, "utf8");
    const base64String = atob(transforms);
    const arrayBuffer = new ArrayBuffer(transforms.length);
    const view = new Uint8Array(arrayBuffer);
    for (let i = 0; i < base64String.length; i++) {
      view[i] = base64String.charCodeAt(i);
    }
    // Crea un blob con los datos del archivo
    const blob = new Blob([view], { type: "application/pdf" });
    return blob;
  };

  const Mostrarfiltros = () => {
    setShowFilters(!showFilters);
  };

  const handleClean = () => {
    console.log("Searching for:", searchTerm);
    setContrato_seleccionado(contrat);
    setJornada_seleccionada(jor);
    setUnidad_seleccionada(uni);
  };

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setItemsPerPage(event.rows);
    console.log(event.rows);
    setCurrentPage(Math.ceil(event.first / itemsPerPage) + 1);
    console.log(event.first);
  };

  const onPageChange2 = (event: { first: number }) => {
    setCurrentPage2(Math.ceil(event.first / 1) + 1);
  };

  const onCheckboxChange = () => {
    setVertodos(!verTodos);
  };

  const handleSearch = () => {
    console.log("Searching for:", searchTerm);
  };

  const startContent = (
    <>
      <div className="card flex justify-content-center">
        <a
          href="https://www.uantof.cl"
          target="_blank"
          rel="noopener noreferrer"
          className="p-button font-bold bg-orange-400"
        >
          Volver
        </a>
      </div>
    </>
  );

  const centerContent = (
    <>
      <div className="grid ">
        <div className="col mr-8 flex">
          <InputText
            placeholder="Buscar concursos"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            className="checkbox-p bg-orange-400"
            icon="pi pi-search"
            onClick={handleClick}
          />
        </div>
        <div className="col ml-8 justify-content-center">
          <label className="font-bold ">Ver concursos finalizados</label>
          <Checkbox
            className="ml-8 flex"
            onChange={onCheckboxChange}
            checked={verTodos}
          />
        </div>
      </div>
    </>
  );

  const endContent = (
    <React.Fragment>
      <Button
        label=" Mostrar Filtros"
        className="bg-orange-400"
        onClick={Mostrarfiltros}
      />
    </React.Fragment>
  );

  return (
    <>
      <PrimeReactProvider>
        <style>{`
        .p-datatable-thead {
          display: none  
        }
      `}</style>
        <div className="">
          <div className=" grid mb-2 bg-blue-500">
            <div className="col-12 flex align-items-center justify-content-between">
              <div className="flex align-items-center ml-4">
                <img
                  alt="logo"
                  src="logo_ua_blanco.png"
                  style={{ maxWidth: "10%" }}
                  className="mr-2"
                />
              </div>
              <div
                className="text-center text-white-alpha-90"
                style={{ fontWeight: "bold" }}
              >
                <span>
                  UNIVERSIDAD DE ANTOFAGASTA <br />
                </span>
                <div
                  className="max-w-16rem custom-divider my-2 mx-auto"
                  style={{
                    borderTop: "2px solid orange",
                    width: "100%",
                    margin: "0 auto",
                  }}
                />
                <span>PORTAL DE CONCURSOS</span>
              </div>
              <div
                className="flex align-items-center mr-4"
                style={{ visibility: "hidden" }}
              >
                <img
                  alt="dummy"
                  src="logo_ua_blanco.png"
                  style={{ maxWidth: "13%" }}
                  className="mr-2"
                />
              </div>
            </div>
          </div>
          <Toolbar
            className="bg-black-alpha-10 border-transparent"
            start={startContent}
            center={centerContent}
            end={endContent}
          />
          {showFilters && (
            <div className="grid bg-black-alpha-10 border-transparent mt-0">
              <div className="col justify-content-center">
                <div className="card flex justify-content-center">
                  <Button
                    label="Limpiar"
                    className="bg-orange-400"
                    onClick={handleClean}
                  />
                </div>
              </div>
              <div className="col justify-content-center">
                <label className="ml-4 font-bold block">
                  Escoja rango de precios
                </label>
                <label className="font-bold ">
                  Min:${formatNumberWithThousandsSeparator(valMin)}
                </label>
                <label className="font-bold ml-2">
                  Max:${formatNumberWithThousandsSeparator(valMax)}
                </label>
                <Slider
                  data-pr-classname="ml-2"
                  value={[valMin, valMax]}
                  onChange={handleSliderChange}
                  className="w-14rem mt-2"
                  range
                  min={0}
                  max={15000000}
                  step={100000}
                  pt={{
                    root: { className: "w-14rem bg-black-alpha-10" },
                    handle: { className: "bg-orange-400 border-500" },
                    range: { className: "bg-orange-400" },
                  }}
                />
              </div>
              <div className="col justify-content-center">
                <Dropdown
                  value={contrato_seleccionado}
                  onChange={(e) => setContrato_seleccionado(e.value)}
                  options={contratos}
                  optionLabel="tipo_c"
                  placeholder="Contrato"
                  className="w-full "
                />
              </div>
              <div className="col justify-content-center">
                <Dropdown
                  value={jornada_seleccionada}
                  onChange={(e) => setJornada_seleccionada(e.value)}
                  options={jornadas}
                  optionLabel="tipo"
                  placeholder="Jornada"
                  className="w-full "
                />
              </div>
              <div className="col justify-content-center">
                <Dropdown
                  value={unidad_seleccionada}
                  onChange={(e) => setUnidad_seleccionada(e.value)}
                  options={unidades}
                  optionLabel="unidad"
                  placeholder="Unidad"
                  className="w-full "
                />
              </div>
              <div className="col justify-content-center">
                <InputText
                  value={cargo}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setCargo(e.target.value)
                  }
                  placeholder="Escriba un cargo"
                />
              </div>
              <div className="col justify-content-center">
                <div className="card flex justify-content-center">
                  <Button
                    label="Filtrar"
                    className="bg-orange-400"
                    onClick={handleClick}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="grid" style={{ padding: "2%" }}>
          <div className="col">
            <DataTable value={Concursos}>
              <Column
                className="w-full p-1"
                body={(rowData: Concurso) => (
                  <Button
                    className="m-0 p-0 border-black-alpha-10 bg-transparent w-full h-rem"
                    onClick={MostrarConcursos(rowData)}
                  >
                    <Card className="w-full ">
                      <h5 className="text-base ">{rowData.titulo}</h5>
                    </Card>
                  </Button>
                )}
              />
            </DataTable>
            <Paginator
              first={(currentPage - 1) * itemsPerPage}
              rows={itemsPerPage}
              totalRecords={Totalpaginas}
              rowsPerPageOptions={[3, 5, 10]}
              onPageChange={onPageChange}
            />
          </div>
          {showInformacion && (
            <div className="col mr-4 text-xs mt-3 flip ">
              <Card>
                <Button
                  className="checkbox-p bg-orange-400 "
                  style={{ left: "90%" }}
                  icon="pi pi-times"
                  onClick={OcultarConcursos}
                />
                <h5 className="text-xl">{Titulo}</h5>

                <Divider className="custom-divider " />
                {cargando ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <ProgressSpinner />
                  </div>
                ) : (
                  <DataTable
                    value={informaciones}
                    paginator
                    first={currentPage2 - 1}
                    rows={1}
                    onPage={onPageChange2}
                  >
                    <Column
                      body={(rowData: informaciones) => (
                        <a
                          href={URL.createObjectURL(
                            hola(rowData.archivo_metadato.archivo.documento)
                          )}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {rowData.titulo}
                        </a>
                      )}
                    />
                  </DataTable>
                )}
                <Divider className="custom-divider" />
              </Card>
            </div>
          )}
        </div>
      </PrimeReactProvider>
    </>
  );
};

export default Plataforma_Concursos;
